var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 69,
    viewBox: "0 0 87 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 32.4C32.1333 33.8667 34.7333 36.0667 36.6 39C38.4667 41.9333 39.4 45.4 39.4 49.4C39.4 55.1333 37.6 59.8 34 63.4C30.4 66.8667 25.8 68.6 20.2 68.6C14.6 68.6 9.93333 66.8 6.2 63.2C2.6 59.6 0.8 55 0.8 49.4C0.8 46.7333 1.13333 44.0667 1.8 41.4C2.46667 38.7333 3.93333 34.7333 6.2 29.4L17.8 0.599991H37.6L28.8 32.4ZM76 32.4C79.3333 33.8667 81.9333 36.0667 83.8 39C85.6667 41.9333 86.6 45.4 86.6 49.4C86.6 55.1333 84.8 59.8 81.2 63.4C77.6 66.8667 73 68.6 67.4 68.6C61.8 68.6 57.1333 66.8 53.4 63.2C49.8 59.6 48 55 48 49.4C48 46.7333 48.3333 44.0667 49 41.4C49.6667 38.7333 51.1333 34.7333 53.4 29.4L65 0.599991H84.8L76 32.4Z",
    fill: "#C82829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.6ac304acdf9c38e242b9feec3c7e1f49.svg";
export { ForwardRef as ReactComponent };